import React from 'react';

const Footer = () => {
    return (
        <div className='bg-dark pt-2 pb-2 text-center'>
            <p><small>Copyright: North Tech All Right Reserved.</small></p>
        </div>
    );
};

export default Footer;